import {
	Button,
	Checkbox,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControl,
	FormHelperText,
	InputAdornment,
	InputLabel,
	ListItemText,
	MenuItem,
	Select,
	Snackbar,
	TextField,
	Typography,
	Icon,
	IconButton
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import MuiAlert from '@material-ui/lab/Alert'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { postAddOns } from '../../actions/addons/addons.actions'
import { DeletableChip } from '../../components/Misc/DeletableChip'
import { CustomAddOnOccurences } from '../Addons/customAddonOccurences'
import { ArrowBackIosOutlined, ArrowForwardIosOutlined } from '@material-ui/icons'
import { VISIT_TYPES } from '../../utils'

import moment from 'moment'

const useStyles = makeStyles((theme) => ({
	dialog: {
		'& .MuiDialog-paper': {
			maxWidth: '920px'
		}
	},
	formWrapper: {
		display: 'flex',
		flexWrap: 'wrap',
		margin: '24px 0px'
	},
	fieldWrapper: {
		'&:nth-child(odd)': {
			marginRight: '25px'
		},
		display: 'flex',
		flexDirection: 'column',
		marginBottom: '20px'
	},
	dialogActions: {
		justifyContent: 'flex-start'
	},
	chips: {
		display: 'flex',
		flexWrap: 'wrap',
		marginTop: '6px',
		backgroundColor: 'transparent !important'
	},
	chip: {
		marginRight: 2
	},
	currencyAdornment: {
		marginLeft: '10px',
		marginTop: '7px !important'
	},
	calendarButton: {
		'& svg': {
			fill: theme.palette.primary.main
		}
	},
	calendarHeaderButtons: {
		fill: theme.palette.primary.main
	},
	datePicker: {
		'& .MuiInputLabel-filled': {
			transform: 'translate(48px, 20px) scale(1)'
		},
		'& .MuiInputLabel-shrink': {
			transform: 'translate(48px, 10px) scale(0.75)'
		},
		'&:nth-child(1)': {
			marginRight: '16px !important'
		}
	}
}))

const Alert = (props) => {
	return <MuiAlert elevation={6} variant="filled" {...props} />
}

const ApplyAddOnDialog = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const selectedFacility = useSelector((state) => state.specific.facilities.selected)
	const facilities = useSelector((state) => state.specific.facilities.facilities)

	const visit = useSelector((state) => state.specific.visits.selected)
	const occurences = ['Every Day', 'Every Other Day', 'Custom']
	const timeBlocks = ['morning', 'midday', 'evening']

	const { isShown, setIsShown, pet } = props
	const [addOnTypeOptions, setAddOnTypeOptions] = useState(null)
	const [facility, setFacility] = useState(null)
	const [addOnType, setAddOnType] = useState(null)
	const [treat, setTreat] = useState(null)
	const [pets, setPets] = useState([pet ? pet : null])
	const [occurence, setOccurence] = useState(null)
	const [timeBlock, setTimeBlock] = useState(visit && visit.type === 'daycare' ? 'midday' : null)
	const [priceChanged, setPriceChanged] = useState(false)
	const [price, setPrice] = useState('0')
	const [customDates, setCustomDates] = useState([])

	// Errors
	const [addOnTypeError, setAddOnTypeError] = useState(false)
	const [treatError, setTreatError] = useState(false)
	const [petsError, setPetsError] = useState(false)
	const [occurenceError, setOccurenceError] = useState(false)
	const [timeBlockError, setTimeBlockError] = useState(false)
	const [isCalendarOpen, setIsCalendarOpen] = useState(false)
	const [hasFormErrors, setHasFormErrors] = useState(false)
	const [isErrorOpen, setErrorOpen] = useState(false)
	const [error, setError] = useState(false)
	const [date, updateDate] = useState(null)
	const [addOnChoice, setAddOnChoice] = useState(null)
	const [addOnChoiceError, setAddOnChoiceError] = useState(false)

	const defaultDate = props.date ? moment(props.date, 'YYYY-MM-DD') : moment()

	useEffect(() => {
		if (defaultDate) {
			updateDate(defaultDate.format('YYYY-MM-DD'))
		}
	}, [defaultDate])

	useEffect(() => {
		if (visit && facilities && facilities.length) {
			let facility = facilities.find((f) => f._id == visit.facility_id)
			setFacility(facility ? facility : null)
		}
	}, [visit, facilities])

	useEffect(() => {
		if (visit?.pet_ids?.length === 1) {
			let ourPet = visit?.pets?.find((p) => p._id == visit.pet_ids[0])
			if (ourPet) setPets([ourPet])
		}
	}, [visit])

	useEffect(() => {
		if (facility) {
			let types =
				facility.addOnTypes?.filter((a) => {
					const {
						grooming_service = false,
						active = true,
						blocked_dates = [],
						limited = false,
						dates = []
					} = a

					const d = date || defaultDate.format('YYYY-MM-DD')

					if (blocked_dates.includes(d)) {
						return false
					}

					if (limited && !dates.includes(d)) {
						return false
					}

					if (visit?.type === VISIT_TYPES.Grooming) {
						return grooming_service && active
					}
					return !grooming_service && active
				}) || []

			setAddOnTypeOptions(types)
		}
	}, [facility, visit, date])

	useEffect(() => {
		if (addOnChoice && addOnType) {
			let choice = addOnType?.addon_choices?.find((ac) => ac.id === addOnChoice)
			if (choice) {
				let upcharge = choice.upcharge || 0
				let newPrice = addOnType.price + upcharge
				setPrice(newPrice)
				setPriceChanged(false)
			}
		}
	}, [addOnChoice])

	const onlyNumbers = (value) => {
		if (!value || value === '0') return value
		const onlyNums = value.toString().replace(/[^\d]/g, '').replace(/^0+/, '')
		if (onlyNums.length) return onlyNums
		return 0
	}

	const formatNumsToDollars = (value) => {
		if (value !== undefined && value !== null) {
			return `${(value / 100).toFixed(2)}`
		}
		return ''
	}

	const createAddOn = () => {
		let errors = validateAddOnForm()

		setHasFormErrors(errors)

		let addOn

		if (errors) {
			showErrorMessage('Please fix form errors.')
		} else {
			if (addOnType === 'meal') {
				addOn = {
					pet_ids: pets.map((pet) => pet._id),
					time: timeBlock,
					date: date || defaultDate.format('YYYY-MM-DD'),
					category: 'meal'
				}

				if (priceChanged) addOn.price = onlyNumbers(price)

				dispatch(postAddOns(visit._id, addOn)).then(() => {
					hideDialog()
				})
			} else {
				addOn = {
					pet_ids: visit.type === 'grooming' ? visit.pet_ids : pets.map((pet) => pet._id),
					time: visit.type === 'grooming' ? 'midday' : timeBlock,
					occurence: visit.type === 'grooming' ? 'Every Day' : occurence,
					customDates: occurence === 'Custom' ? customDates : null,
					addon_id: addOnType._id
					// price: price
				}

				if (addOnChoice) addOn.addon_choice_id = addOnChoice

				if (priceChanged) addOn.price = onlyNumbers(price)

				dispatch(postAddOns(visit._id, addOn)).then(() => {
					hideDialog()
				})
			}
		}
	}

	const updateAddOnType = (e) => {
		let value = e.target.value

		setPrice(value.price || value.min_price || '0')

		setAddOnType(value)
	}

	const validateAddOnForm = () => {
		if (visit.type === 'grooming') {
			if (!addOnType) return true
			if (addOnType?.addon_choices?.length > 1 && !addOnChoice) return true
			return false
		}

		if (addOnType === 'meal' && date) {
			const dates = getAvailableDates()
			if (!dates.includes(date)) return true
		}

		let isCustomOccurence = occurence === 'Custom'

		setAddOnTypeError(Boolean(!addOnType))

		if (visit.type === 'boarding' && addOnType !== 'meal') {
			setOccurenceError(Boolean(!occurence))
		}

		if (isCustomOccurence) {
			validateCustomOccurences()
		} else {
			setTimeBlockError(Boolean(!timeBlock))
		}

		const numPets = pets.length
		if (!numPets > 0) {
			setPetsError(true)
			return true
		}

		if (addOnType?.addon_choices?.length > 1 && !addOnChoice) {
			setAddOnChoiceError(true)
			return true
		}

		return (
			!addOnType ||
			!pets.length > 0 ||
			(visit.type && visit.type === 'boarding' && addOnType !== 'meal' && !occurence) ||
			(!isCustomOccurence && !timeBlock) ||
			customDates.some((customDate) => customDate.dateError || customDate.timeBlockError)
		)
	}

	const validateCustomOccurences = () => {
		customDates.forEach((customDate) => {
			customDate.dateError = !customDate.date ? true : false
			customDate.timeBlockError = !customDate.time ? true : false
		})

		setCustomDates(customDates)
	}

	const showErrorMessage = (error) => {
		setError(error)
		setErrorOpen(true)
	}

	const handleCloseError = (event, reason) => {
		if (reason === 'clickaway') {
			return
		}

		setErrorOpen(false)
	}

	const renderSelectedAddOns = () => {
		let addOns = facility?.add_on_services?.[addOnType]

		return addOns && addOns.length > 0
			? addOns.map((addOn) => (
				<MenuItem key={addOn._id} value={addOn}>
					<Typography style={{ textTransform: 'capitalize' }}>{addOn.name}</Typography>
				</MenuItem>
			))
			: null
	}

	const removePet = (value) => {
		setPets(pets.filter((pet) => pet._id !== value._id))
	}

	const hideDialog = () => {
		clearForm()
		handleCloseError()
		clearFormErrors()
		setIsShown(false)
	}

	const clearForm = () => {
		setAddOnType(null)
		setTreat(null)
		setPets([])
		setOccurence(null)
		setCustomDates([])
		setPriceChanged(false)
		if (visit.type !== 'daycare') {
			setTimeBlock(null)
		}

		clearFormErrors()
	}

	const clearFormErrors = () => {
		setAddOnTypeError(false)
		setTreatError(false)
		setPetsError(false)
		setOccurenceError(false)
		setTimeBlockError(false)
		setPrice(0)

		setHasFormErrors(false)
	}

	useEffect(() => {
		return () => {
			clearForm()
		}
	}, [isShown])

	useEffect(() => {
		if (hasFormErrors) {
			validateAddOnForm()
		}
	})

	const getAvailableDates = () => {
		if (!visit.dates.length) return []
		return visit.dates.filter((d) => !moment(d, 'YYYY-MM-DD').isBefore(moment().startOf('day')))
	}

	const minDate = getAvailableDates()[0]

	return (
		<Dialog
			open={isShown}
			onClose={() => hideDialog()}
			aria-labelledby="form-dialog-title"
			className={classes.dialog}>
			<DialogTitle style={{ textTransform: 'uppercase' }}>
				{visit?.type === 'grooming' ? 'Add Grooming Enrichment' : 'Add Activity'}
			</DialogTitle>
			<DialogContent>
				<div className={classes.formWrapper}>
					{addOnTypeOptions ? (
						<div className={classes.fieldWrapper}>
							<Typography variant="overline">Select Activity Type</Typography>
							<TextField
								id="add-on-select"
								variant="filled"
								select
								label="Activity Type"
								value={addOnType || ''}
								onChange={(e) => updateAddOnType(e)}
								InputProps={{ className: addOnType ? classes.selected : '' }}
								error={addOnTypeError}
								helperText={addOnTypeError ? 'Please select an enrichment type.' : null}>
								{visit?.type !== 'grooming' && (
									<MenuItem key={`mealAddOnKey`} value="meal">
										<Typography style={{ textTransform: 'capitalize' }}>Meal</Typography>
									</MenuItem>
								)}
								{addOnTypeOptions
									? addOnTypeOptions
										.filter((a) => a.active)
										.filter((a) => a.name !== 'Grooming Services')
										.map((addOnTypeOption) => (
											<MenuItem key={addOnTypeOption} value={addOnTypeOption}>
												<Typography style={{ textTransform: 'capitalize' }}>
													{addOnTypeOption.name}
												</Typography>
											</MenuItem>
										))
									: null}
							</TextField>
						</div>
					) : (
						<Typography>No Facility Enrichments</Typography>
					)}

					{addOnType && addOnType?.addon_choices?.length > 1 ? (
						<div className={classes.fieldWrapper}>
							<Typography variant="overline">Select Enrichment Choice</Typography>
							<FormControl className={classes.select}>
								<TextField
									id="time-select"
									label="Enrichment Choice"
									variant="filled"
									select
									value={addOnChoice || ''}
									onChange={(e, yeah) => {
										setAddOnChoice(e.target.value)
										setAddOnChoiceError(false)
									}}
									error={addOnChoiceError}>
									{addOnType.addon_choices.map((choice) => (
										<MenuItem key={timeBlock} value={choice.id}>
											{choice.name}
										</MenuItem>
									))}
								</TextField>
								{addOnChoiceError ? (
									<FormHelperText>Please select enrichment choice</FormHelperText>
								) : null}
							</FormControl>
						</div>
					) : null}

					{addOnType && visit?.type !== 'grooming' ? (
						<div className={classes.fieldWrapper}>
							<Typography variant="overline">for which pets</Typography>
							<FormControl className={classes.select}>
								<InputLabel id="pets-label" style={{ color: petsError ? '#f44336' : null }}>
									Pets
								</InputLabel>
								<Select
									labelId="pets-label"
									id="pets-select"
									variant="filled"
									value={pets}
									disabled={pets.length > 0}
									label="Pets"
									multiple
									renderValue={(selected) => (
										<div className={classes.chips}>
											{selected.map((value) => (
												<DeletableChip
													key={value._id}
													label={value.name}
													className={classes.chip}
													onDelete={() => removePet(value)}
												/>
											))}
										</div>
									)}
									onChange={(e) => setPets(e.target.value)}
									error={petsError}>
									{visit.pets ? (
										visit.pets.map((pet) => (
											<MenuItem key={pet._id} value={pet}>
												<Checkbox checked={pets.indexOf(pet) > -1} />
												<ListItemText primary={pet.name} />
											</MenuItem>
										))
									) : (
										<MenuItem>No pets</MenuItem>
									)}
								</Select>
								{petsError ? <FormHelperText>Please select pet(s)</FormHelperText> : null}
							</FormControl>
						</div>
					) : null}
					{addOnType && addOnType !== 'meal' && visit.type === 'boarding' ? (
						<div className={classes.fieldWrapper}>
							<Typography variant="overline">How Often</Typography>
							<TextField
								id="often-select"
								variant="filled"
								select
								label="Occurrences"
								value={occurence || ''}
								onChange={(e) => setOccurence(e.target.value)}
								InputProps={{ className: occurence ? classes.selected : '' }}
								error={occurenceError}
								helperText={occurenceError ? 'Please select an occurence.' : null}>
								{occurences.map((occurence) => (
									<MenuItem key={occurence} value={occurence}>
										{occurence}
									</MenuItem>
								))}
							</TextField>
						</div>
					) : null}
					{addOnType && addOnType === 'meal' ? (
						<div className={classes.fieldWrapper}>
							<Typography variant="overline">Date</Typography>
							<KeyboardDatePicker
								disableToolbar
								style={{
									minWidth: '400px',
									margin: 0
								}}
								InputAdornmentProps={{
									position: 'start',
									component: () => (
										<IconButton onClick={() => setIsCalendarOpen(true)}>
											<Icon
												className="far fa-calendar-alt"
												style={{
													fontSize: '1.325rem'
												}}
											/>
										</IconButton>
									)
								}}
								InputProps={
									{
										// error: customDate.dateError
									}
								}
								open={isCalendarOpen}
								onClose={() => setIsCalendarOpen(false)}
								variant="inline"
								format="MM/DD/YYYY"
								margin="normal"
								label="Date"
								inputVariant="filled"
								value={date ? moment(date, 'YYYY-MM-DD') : defaultDate}
								onChange={(d) => {
									const newDate = d.format('YYYY-MM-DD')
									updateDate(newDate)
								}}
								className={classes.datePicker}
								rightArrowIcon={
									<ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />
								}
								leftArrowIcon={<ArrowBackIosOutlined className={classes.calendarHeaderButtons} />}
								KeyboardButtonProps={{
									'aria-label': 'Date',
									className: classes.calendarButton
								}}
								minDate={minDate}
								maxDate={
									visit && visit.dates.length > 1 ? visit.dates[visit.dates.length - 1] : null
								}
								disablePast
							/>
						</div>
					) : null}
					{addOnType && occurence === 'Custom' ? (
						<CustomAddOnOccurences
							customDates={customDates}
							setCustomDates={setCustomDates}
							timeBlocks={timeBlocks}
						/>
					) : null}
					{addOnType && occurence !== 'Custom' && visit?.type !== 'grooming' ? (
						<div className={classes.fieldWrapper}>
							<Typography variant="overline">At this time of day</Typography>
							<TextField
								id="time-select"
								variant="filled"
								select
								label="Time Block"
								value={timeBlock || ''}
								onChange={(e) => setTimeBlock(e.target.value)}
								InputProps={{ className: timeBlock ? classes.selected : '' }}
								error={timeBlockError}
								helperText={timeBlockError ? 'Please select a time block.' : null}>
								{timeBlocks
									.filter((t) => {
										if (visit.type === 'daycare') {
											if (visit.early_dropoff && visit.extended_pickup) return true
											if (visit.early_dropoff) return t === 'morning' || t === 'midday'
											if (visit.extended_pickup) return t === 'midday' || t === 'evening'
											return t === 'midday'
										}

										// TODO: need to add logic to restrict time blocks for boarding visits (can get tricky since they can be multiple days with different time blocks)
										return true
									})
									.map((timeBlock) => (
										<MenuItem key={timeBlock} value={timeBlock}>
											{timeBlock}
										</MenuItem>
									))}
							</TextField>
						</div>
					) : null}
					{addOnType ? (
						<div className={classes.fieldWrapper}>
							<Typography variant="overline">Edit Default Pricing</Typography>
							<TextField
								id="price"
								variant="filled"
								label="Price"
								value={formatNumsToDollars(onlyNumbers(price))}
								onChange={(e) => {
									setPrice(e.target.value)
									setPriceChanged(true)
								}}
								helperText={'Total price (base cost plus any upcharges)'}
								InputProps={{
									startAdornment: (
										<InputAdornment className={classes.currencyAdornment} position="start">
											$
										</InputAdornment>
									)
								}}
							/>
						</div>
					) : null}
				</div>
				<Snackbar
					open={isErrorOpen}
					autoHideDuration={6000}
					anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
					onClose={handleCloseError}>
					<Alert onClose={handleCloseError} severity="error">
						{error}
					</Alert>
				</Snackbar>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button variant="contained" onClick={createAddOn} color="secondary">
					Apply
				</Button>
				<Button variant="outlined" onClick={() => hideDialog()} color="secondary">
					Cancel
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default ApplyAddOnDialog
